import * as React from 'react';
import { SVGProps } from 'react';

const SvgRattler = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M19.847 21.77a6.314 6.314 0 0 1-6.307-6.306 6.315 6.315 0 0 1 6.307-6.307 6.315 6.315 0 0 1 6.306 6.307 6.314 6.314 0 0 1-6.306 6.306Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M22.113 34.875h-4.549v-9.307l-.543-.156A10.38 10.38 0 0 1 9.5 15.463 10.355 10.355 0 0 1 19.846 5.125a10.355 10.355 0 0 1 10.34 10.339 10.375 10.375 0 0 1-7.521 9.952l-.544.155v.566l-.008 8.738Z"
    />
    <path fill={props.fill} d="M28.451 27.56H13.794v4.033H24.4l4.052-4.032Z" />
    <path
      fill="currentColor"
      d="M22.363 18.496v-6.06h-2.016v6.06h2.016Zm-3.024 0v-6.06h-2.016v6.06h2.016Z"
    />
  </svg>
);

export default SvgRattler;
